import { render, staticRenderFns } from "./timeout-page.vue?vue&type=template&id=69b65841&scoped=true"
import script from "./timeout-page.vue?vue&type=script&lang=js"
export * from "./timeout-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b65841",
  null
  
)

export default component.exports